<template>
  <v-dialog persistent v-model="show" max-width="290">
    <v-card class="text-left">
      <!-- <v-card-text>Bitte Bild anpassen.</v-card-text> -->
      <div class="pb-4"></div>
      <!-- <vue-croppie
          ref="croppieRef"
          :enableOrientation="true"
          :boundary="boundary"
          :viewport="viewport">
        </vue-croppie> -->

      <cropper
        class="cropper"
        ref="croppieRef"
        :src="image"
        :stencil-props="stencilProps"
        :stencil-component="
          circle
            ? $options.components.CircleStencil
            : $options.components.RectangleStencil
        "
        image-restriction="stencil"
      />

      <v-card-actions style="justify-content: center">
        <v-btn color="green--text" text @click="$emit('update:show', false)"
          >Abbrechen</v-btn
        >
        <v-btn color="green white--text" text @click="$emit('upload')">Upload</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Cropper, CircleStencil, RectangleStencil } from 'vue-advanced-cropper';

export default {
  name: 'croppie-dialog',

  components: {
    Cropper,
    CircleStencil,
    RectangleStencil,
  },

  props: {
    image: {
      type: String,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
    circle: {
      type: Boolean,
      default: true,
    },
    gallery: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    this.stencilProps = {
      handlers: {},
      movable: false,
      scalable: false,
      aspectRatio: this.gallery ? 1.33 : 1,
    };
  },
};
</script>

<style lang="scss">
.cropper {
  height: 300px;
}
</style>
